import React from "react";
import { PixiComponent, useApp } from "@inlet/react-pixi";
import { Viewport as PixiViewport } from "pixi-viewport";
import type { Application, DisplayObject } from "pixi.js";

type ViewportInnerComponentProps = {
  app: Application;
};

const ViewportInnerComponent = PixiComponent<
  ViewportInnerComponentProps,
  DisplayObject
>("Viewport", {
  create: (props) => {
    const viewport = new PixiViewport({
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      worldWidth: 1000,
      worldHeight: 1000,
      ticker: props.app.ticker,
      interaction: props.app.renderer.plugins.interaction,
    });

    viewport.drag().pinch().wheel().decelerate();

    return viewport;
  },
});

const Viewport: React.FC = ({ children }) => {
  const app = useApp();
  return <ViewportInnerComponent app={app}>{children}</ViewportInnerComponent>;
};

export default Viewport;
